export const Constants = {
  TAG_NAME: 'pop-sector-attribution-table-component',
  SECTOR_COLUMN_HEADER: 'Sector',
  TOTAL_VALUE_ADDED_COLUMN_HEADER: 'Total value added %',
  VALUE_FROM_SECTOR_WEIGHT_COLUMN_HEADER: 'Value from sector weight %',
  VALUE_FROM_STOCK_SELECTION_COLUMN_HEADER: 'Value from stock selection %',
  EMPTY_CELL_VALUE: 'N/A',
} as const;
